module.exports = __webpack_public_path__ + "img/gs-img-3_ja.2a2fdcca.png";